import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { codeVerificationSSO } from '../../../apirapper/user.ts';
import { useNavigate } from "react-router-dom";

const TwostepverificationTwo = () => {
  const route = all_routes;
  const [timeLeft, setTimeLeft] = useState(180); // 24 hours in seconds
  const [passwordError, setPasswordError] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    // Clear timeout if component is unmounted or timeLeft becomes 0
    return () => clearTimeout(timer);
  }, [timeLeft]);

  const handlePasswordChange = (index, value) => {
    const newPassword = [...password];
    newPassword[index] = value;
    setPassword(newPassword.join(''));
    if (newPassword.join('').length === 6) {
      setPasswordError("");
    } else {
      setPasswordError("Password must be 6 digits long.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length !== 6) {
      
      setPasswordError("Password must be 6 digits long.");
      return;
    }
    console.log('password',password);

    // Assuming your API call function is called 'resetPassword'
    const apiResponse = await codeVerificationSSO(password); // Replace resetPassword with your API call function
    console.log('apiResponse',apiResponse);
    const data ={
      code:password
    }
    if (apiResponse == '200') {
      navigate(route.resetpasswordTwo, { state: data });
    } else {
      setPasswordError(apiResponse);
      console.log("API error");
    }
  };

  const renderTimer = () => {
    // const hours = Math.floor(timeLeft / 3600);
    const minutes = Math.floor((timeLeft % 3600) / 60);
    const seconds = timeLeft % 60;

    return (
      <div className="Otp-expire text-center">
        <p>Otp will expire in {minutes.toString().padStart(2, "0")} : {seconds.toString().padStart(2, "0")}</p>
      </div>
    );
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper">
          <div className="login-img">
            <ImageWithBasePath src="assets/img/authentication/login02.png" alt="img" />
          </div>
          <div className="login-content">
            <div className="login-userset">
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
              </div>
              <Link to={route.dashboard} className="login-logo logo-white">
                <ImageWithBasePath src="assets/img/logo-white.png" alt />
              </Link>
              <div className="login-userheading">
                <h3>Signin With Your Email Address</h3>
                <h4 className="verfy-mail-content">
                  We sent a verification code to your email. Enter the code from
                  the email in the field below
                </h4>
              </div>
              <form onSubmit={handleSubmit} className="digit-group">
                <div className="wallet-add">
                  <div className="otp-box">
                    <div className="forms-block text-center">
                      {[1, 2, 3, 4, 5, 6].map(index => (
                        <input
                          key={index}
                          type="text"
                          id={`digit-${index}`}
                          maxLength={1}
                          onChange={(e) => handlePasswordChange(index - 1, e.target.value)}
                        />
                      ))}
                    </div>
                  </div>
                </div>
                {passwordError && <div className="error-message text-danger">{passwordError}</div>}
                {renderTimer()}
                <div className="form-login mt-4">
                  <button type="submit" className="btn btn-login">
                    Verify My Account
                  </button>
                </div>
              </form>
              <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                <p>Copyright © 2024 WizzTech. All rights reserved</p>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default TwostepverificationTwo;
